module.exports = __webpack_public_path__ + "static/img/RAWP-1R_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAWP-1R_1.png
// module id = 3z4D
// module chunks = 0